import Meta from "@/layout/Meta"
import withAuth from "@/modules/HOC/WithAuth/withAuth"
import ProfileContainer from "@/modules/profile/Profile.container"
import Main from "@/templates/Main"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "usehooks-ts"

const Profile: React.FC = () => {
  const { t } = useTranslation()

  let isMobile = useMediaQuery("(max-width: 1080px)")
  return (
    <Main meta={<Meta title={t("common.profile")} description={t("profile.Meta.description")} />}>
      <div id="profile-page" className={`h-full w-full flex ${isMobile ? "flex-col" : "flex-row"}`}>
        <ProfileContainer />
      </div>
    </Main>
  )
}

export default withAuth(Profile) as any
